export enum TypeRevendication {
    PARTIELLE = 'partielle',
    TOTALE = 'totale'
}
